import { ID } from "shared/interfaces/common";

export default {
    SETTINGS: {
        SETTINGS_SYSTEM: "api/v1/settings",
    },
    NOTIFICATIONS: {
        ROOT: "api/v1/notifications",
        NOT_READ_COUNT: "api/v1/notifications/not-read-count",
        MARK_AS_READ: "api/v1/notifications/mark-all-as-read",
        DELETE_NOTIFICATION: (id: ID): string => `api/v1/notifications/${id}`,
        DELETE_ALL_NOTIFICATION: "api/v1/notifications",
    },
};
